export default __webpack_public_path__ + "7339202d5c13ea0c704073b05fd9fb76.svg";